import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import CurrencyCardIcon from '../utils/currency-card-icon.js';


class OrderCreateForm extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.quote = null;
		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: ''};
		let signingkey = null;
		let currentcard = null;
		let balance = '';
		
		this.state = {
			title,
			description,
			amount,
			currency,
			signingkey,
			currentcard,
			balance,
			message_text: '',
			processinginfo: 'processing submission',
			processing: false
		};
	}

	
	// post render commit phase
	componentDidUpdate(prevProps, prevState) {
		console.log('OrderCreateForm.componentDidUpdate called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		// entered a private key
		if (this.state.signingkey != prevState.signingkey) {
			const {currency} = this.state;

			if ( (currency) && (currency.uuid)) {
				let currentcard = null;
				let balance = '';
				
				let currencyuuid = currency.uuid;

				this.app.createCurrencyCard(currencyuuid, this.state.signingkey, {maincard: true})
				.then(card => {
					currentcard = card;

					return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid)
				})
				.then((pos) => {
					return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				})
				.then((balance) => {
					this.setState({currentcard, balance});
				})
				.catch(err => {
					this.setState({currentcard, balance})
				});
			}
		}
	}

	componentDidMount() {
		console.log('OrderCreateForm.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();
		let rootsessionuuid = this.props.rootsessionuuid;
		
		// message translated in user's language
		let message_text = mvcmyquote.t(
			'When you press the button \'Place Order\', a url will be generated that you will \
			be able to send to your supplier proving you have accepted the quote. \
			If you haven\'t yet provided your private key, you will be asked to enter it \
			at the next step so that your order is signed. \
			Your order will then be registered and be accessible to anyone clicking on \
			the link that has been generated.');
	
		this.setState({message_text});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;


		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		// check wallet is unlocked
		let unlocked = await this.app.checkWalletUnlocked()
		.catch(err => {
		});

		if (!unlocked) {
			let params = (app_nav_target ? app_nav_target.params : null);
			this.app.gotoRoute('login', params);
			return;
		}
		else {
			// check it is not the device wallet, because we need a safer wallet
			let isdevicewallet = await this.app.isDeviceWallet();
			
			if (isdevicewallet) {
				await this.app.resetWallet();
				
			   let params = (app_nav_target ? app_nav_target.params : null);
			   this.app.gotoRoute('login', params);
			   return;
			 }
	   }
		

		if (app_nav_target && (app_nav_target.route == 'order') && (app_nav_target.reached == false)) {
			let params = app_nav_target.params;
			let dataobj = params.dataobject;

			let quote = dataobj
			this.quote = dataobj;

			if (quote) {
				let title = quote.title;
				let description = quote.description;
				let amount = quote.amount;
				let currencyuuid = quote.currencyuuid;

				let currency = {symbol: ''};
				let currentcard;
				let balance = '';

				const cur = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {});

				if (cur)
				currency = cur;

				// get currency position
				currentcard = await this.app.openCurrencyCard(currencyuuid)
				.catch(err => {});

				if (currentcard) {
					let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid);
			
					if (pos !== undefined)
						balance = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
	
				}
	
			
				this.setState({title, description, amount, currency, currentcard, balance });
	
				dataobj.viewed = true;
			}
			else {
				this.app.error('no data object for order create form')
			}
			
			app_nav_target.reached = true;
		}
	}
	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		let wallet;
		let carduuid;
		let card;
		
		let { title, amount, currency, currentcard, signingkey, balance} = this.state;

		this.setState({processing: true});

		try {

			if (!currency || !currency.uuid) {
				this.app.alert('You need to specify a valid currency');
				this.setState({processing: false});
				return;
			}
	
			// get wallet details
			wallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
	
			if (currentcard) {
				card = currentcard;
				carduuid = card.uuid;
			}
			else {
				if (signingkey) {
					let currencyuuid = currency.uuid;
		
					card = await this.app.createCurrencyCard(currencyuuid, signingkey, {maincard: true})
					.catch(err => {
						console.log('error in OrderCreateForm.onSubmit: ' + err);
					});
	
					if (!card) {
						this.app.alert('could not create card from private key');
						this.setState({processing: false});
						return;
					}
				}
				else {
					this.app.alert('You need to provide your private key for ' + currency.name + ' to sign your order');
					this.setState({processing: false});
					return;
				}
		
			}
	
			// we get the pretrade card to save a transaction
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, carduuid, currency.uuid)
			.catch(err => {
				console.log('error in OrderCreateForm.onSubmit: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the order');
				this.setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in OrderCreateForm.onSubmit: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to register order. Wait a few seconds and try again.');
				this.setState({processing: false});
				return;
			}
			else {
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this.setState({processing: false});
					return;
				}
			} 
	
			// we crypt our details with the vendor's public key
			// using our pretradecard that will provide our owner_rsa_publickey
			let quote = this.quote;
			let vendor_address = quote.owner;
			let vendor_rsa_publickey = quote.owner_rsa_publickey;
	
			let buyername = wallet.ownername
			let buyeremail = wallet.owneremail;
	
			const buyername_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, vendor_rsa_publickey, buyername)
			.catch(err => {
				console.log('error in OrderCreateForm.onSubmit: ' + err);
			});
			const buyeremail_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, vendor_rsa_publickey, buyeremail)
			.catch(err => {
				console.log('error in OrderCreateForm.onSubmit: ' + err);
			});
	
	
			// send transaction
			let buyer_address = pretradecard.address;
			let buyer_rsa_publickey = pretradecard.publickeys['rsa_public_key'];
	
			let hadfunds = ((amount <= balance) ? '1' : '0');
	
	
			let order = {type: 'order', quote: quote.txhash, currencyuuid: currency.uuid,
						amount, currency: currency.symbol, hadfunds,
						owner: buyer_address, owner_rsa_publickey: buyer_rsa_publickey, ownername: buyername_encrypted,  owneremail: buyeremail_encrypted};
			let assignto = vendor_address;
	
			let txhash = await mvcmyquote.registerTransaction(rootsessionuuid, walletuuid, pretradecard.uuid, order, assignto)
			.catch(err => {
				console.log('error in OrderCreateForm.onSubmit: ' + err);
			});
	
			if (!txhash) {
				this.app.alert('Could not register the order');
				this.setState({processing: false});
				return;
			}
	
			// get share link
			var orderurl = await this.app.getShareLink(txhash, currency.uuid);
	
			//this.app.alert('Send url ' + orderurl);
	
			// go to list view (to let time for the blockchain to commit the transactions)
			let params = {action: 'view', txhash, currencyuuid: currency.uuid};
	
			await this.app.gotoRoute('orders', params);
	
			this.setState({processing: false});
	
			return true;
		}
		catch(e) {
			console.log('exception in onSubmit: ' + e);
			this.setState({processing: false});
		}

	}

	
	// rendering
	renderOrderCreateForm() {
		let { title, description, amount, currency, currentcard, signingkey, balance, message_text } = this.state;
		
		return (
			<div className="Form">
				<div>
					<FormGroup controlId="title">
						<FormLabel>Quote Title</FormLabel>
						<FormControl
							disabled
							autoFocus
							type="text"
							value={title}
							onChange={e => this.setState({title: e.target.value})}
						/>
					</FormGroup>

					<FormGroup controlId="description">
						<FormLabel>Description</FormLabel>
						<FormControl 
							disabled
							as="textarea" 
							rows="5" 
							autoFocus
							type="text"
							value={description}
							onChange={e => this.setState({description: e.target.value})}
						/>
					</FormGroup>
				
					<FormGroup className="Proposal" controlId="proposal">
						<span className="ProposalCol">
							<FormLabel>Amount</FormLabel>
							<FormControl 
								disabled
								autoFocus
								type="text"
								value={amount}
								onChange={e => this.setState({amount: e.target.value})}
							/>
						</span>

						<span className="ProposalCol">
							<FormLabel>Currency</FormLabel>
							<InputGroup>
								<FormControl 
									disabled
									autoFocus
									type="text"
									value={currency.symbol}
									onChange={e => this.onChangeCurrency(e)}
								/>
							</InputGroup>
						</span>

					</FormGroup>

					{(currentcard ?
						<FormGroup className="CurrencyCard" controlId="address">
							<span className="CardIconCol">
								<CurrencyCardIcon
									app={this.app}
									currency={currency}
									card={currentcard}
								/>
							</span>
							<span className="CardBalanceCol">
								<FormLabel>Balance</FormLabel>
								<FormControl
									className="CardBalanceCol"
									disabled
									autoFocus
									type="text"
									value={balance}
								/>
							</span>
						</FormGroup> :
						<FormGroup controlId="signingkey">
							<FormLabel>Private key {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
							<FormControl
								autoFocus
								type="text"
								value={(signingkey ? signingkey : '')}
								onChange={e => this.setState({signingkey: e.target.value})}
							/>
						</FormGroup>
					)}
					
					<Button 
					disabled={(currentcard ? false : true)}
					onClick={this.onSubmit.bind(this)} 
					type="submit">
					Place Order
					</Button>

					<div className="TextBox">
					{message_text}
					</div>

				</div>
			</div>
		  );
	}

	render() {
		let {processing} = this.state; 

		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}
		
		return (
			<div className="Container">
				<div className="Title">Create Order</div>
				{ this.renderOrderCreateForm()}
			</div>
		  );
	}
	
}


// propTypes validation
OrderCreateForm.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {OrderCreateForm};
export default connect(mapStateToProps, mapDispatchToProps)(OrderCreateForm);

